import { logUserActivity } from './api';
// import { useAuth } from '../contexts/AuthContext'; // Adjust path based on your auth context location

/**
 * Placeholder function to get the current user's email.
 * IMPLEMENT THIS based on your authentication system (e.g., context, Redux, localStorage).
 */
const getCurrentUserEmail = () => {
  // Example: Using localStorage if you store it there directly (adjust key as needed)
  // const userEmail = localStorage.getItem('userEmail');
  // Example: Using an Auth Context (assuming useAuth hook exists)
  // try {
  //   const { user } = useAuth();
  //   return user?.email || 'anonymous';
  // } catch (e) {
  //   console.error("Auth context not available or user not logged in", e);
  //   return 'error-getting-email';
  // }

  
  // *** Replace this placeholder ***
  console.warn("getCurrentUserEmail() is a placeholder. Implement based on your auth state.");
  // Check common localStorage pattern from api.js
  const lastAuthUserKey = Object.keys(localStorage).find(key => key.endsWith('.LastAuthUser'));
  const cognitoUsernameOrEmail = lastAuthUserKey ? localStorage.getItem(lastAuthUserKey) : null;
  // This might be a username or email - adjust if needed
  return cognitoUsernameOrEmail || 'unknown_user';
};

/**
 * Tracks user activity by sending data to the backend.
 * Assumes userId and userEmail are provided from the calling context (e.g., fetched via useUserSettings).
 *
 * @param {object} options - Options for the activity log.
 * @param {string} options.urlPath - The current URL path.
 * @param {string} options.userId - The ID of the user (e.g., Cognito sub).
 * @param {string} options.userEmail - The email address of the user.
 * @param {string} [options.pbiReport] - Optional Power BI Report ID or name.
 * @param {string} [options.pbiPage] - Optional Power BI Page ID or name.
 * @param {string} [options.pbiDashboard] - Optional Power BI Dashboard ID or name.
 * @param {object} [options.pbiFilters] - Optional Power BI filters object.
 */
export const trackActivity = ({
  urlPath,
  userId,
  userEmail,
  pbiReport,
  pbiPage,
  pbiDashboard,
  pbiFilters
}) => {

  // Basic validation for required fields provided by the caller
  if (!userId || !userEmail || !urlPath) {
    console.warn('trackActivity called with missing userId, userEmail, or urlPath.', 
      { userId, userEmail, urlPath });
    return;
  }

  const activityData = {
    userId,
    userEmail,
    urlPath,
    pbiReport: pbiReport || null,
    pbiPage: pbiPage || null,
    pbiDashboard: pbiDashboard || null,
    pbiFilters: pbiFilters || null,
  };

  // Call the API function (fire and forget)
  logUserActivity(activityData);
}; 